import {useEffect,useState} from 'react';

const  InfiniteScroll = (props) => {
  const {
    children,
    viewHeight,
    itemHeight,
    speed,
    listLength,
    isNoseToTail,
    moveHeight = itemHeight * listLength - viewHeight,
  } = props
  const [cycleStart, setcycleStart] = useState(0)
  let timer = null
  let chushu = isNoseToTail ? (moveHeight * 2) / speed + 50 / speed : (moveHeight * 2) / speed
  const px2vh = (px) => {  
    return px +'px';
  }
  const _running = (value) => {
    value = value + 1
    let tmp = value % chushu
    setcycleStart(tmp)
    timer = requestAnimationFrame(() => {
      _running(tmp)
    })
  }
 
  useEffect(() => {
    _running(2)
    return () => {
      timer && cancelAnimationFrame(timer)
    }
  }, [])
 
  //	如果是首尾相连滚动，渲染两次防止出现空白区域
  return (
    <div style={{ height: px2vh(408), overflow: 'hidden' }}>
      {isNoseToTail ? (
        <div style={{ transform: `translateY(${px2vh(-cycleStart * speed)})` }}>
          {children}
          {children}
        </div>
      ) : (
        <div
          style={
            cycleStart > moveHeight / speed - 1
              ? { transform: `translateY(${px2vh(cycleStart * speed - moveHeight * 2)})` }
              : { transform: `translateY(${px2vh(-moveHeight)})` }
          }
        >
          {children}
          {children}
        </div>
      )}
    </div>
  )
}

export default InfiniteScroll;